<template>
  <v-layout
    justify-center
  >
    <qrcode-reader
      :camera="camera"
      @init="onInit"
      @decode="onDecode"
    />
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { QrcodeReader } from 'vue-qrcode-reader'
export default {
  components: {
    QrcodeReader
  },
  data () {
    return {
      camera: {
        audio: false, // don't request microphone access
        video: {
          facingMode: { ideal: 'environment' }, // use rear camera if available
          width: { min: 360, ideal: 680, max: 1920 }, // constrain video width resolution
          height: { min: 240, ideal: 480, max: 1080 } // constrain video height resolution
        }
      },
      data: false
    }
  },
  computed: {
    ...mapGetters({
      person: 'person/person'
    })
  },
  methods: {
    async onInit (promise) {
      // show loading indicator

      try {
        await promise

        // successfully initialized
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera.
          // Did you requested the front camera although there is none?
        } else {
          // browser might be lacking features (WebRTC, ...)
        }
      } finally {
        // hide loading indicator
      }
    },
    onDecode (decodedString) {
      this.data = JSON.parse(decodedString)
      this.loadPerson()
    },
    ...mapActions({
      getPerson: 'person/getPerson',
      setProxyPerson: 'person/setProxyPerson'
    }),
    loadPerson () {
      this.getPerson({ personID: this.data.personID }).then((payload) => {
        this.setProxyPerson(payload.data)
      })
    }
  }
}
</script>
<style>
  .qrcode-reader {
    width: 40vh;
  }
</style>
